import React from 'react';
import { Header, Footer } from '../../component/index';

class Home extends React.Component {
    constructor(props) {
        super(props)
        this.state = { changeHeader: false }
        this.onScroll = this.onScroll.bind(this)
    }
    componentDidMount() {
        window.addEventListener("scroll", this.onScroll, false);
    }
    componentWillUnmount() {
        window.removeEventListener("scroll", this.onScroll, false);
    }
    onScroll() {
        if(window.scrollY >= 200) this.setState({ changeHeader: true })
        else this.setState({ changeHeader: false })
    }
    render() {
        return (
            <>
            <Header homepage={ !this.state.changeHeader ? true : false } />
            <div className="wrapper pt-0">
                <div className="container-w-lg">
                    <div className="row">
                        <img src={process.env.PUBLIC_URL + "/static/images/img_banner_index@2x.png"} alt="give-me-background" width="100%" height="80%" />
                        <div className="col-sm-12 carousel-control">
                            <div id="carouselCaptions" className="carousel slide" data-ride="carousel">
                                <div className="carousel-inner">
                                    <div className="carousel-item active">
                                        <h1 className="item-title">Contacts <span className="text-white">Sharing</span></h1>
                                        <p className="item-content">Share business cards among colleagues and create sustainable network of contacts</p>
                                        <button type="button" className="btn btn-outline-secondary text-white w-md mb-4 mr-2">Video</button>
                                        <button type="button" className="btn btn-primary w-md mb-4 mr-2">Free Trial</button>
                                    </div>
                                    <div className="carousel-item">
                                        <h1 className="item-title">Contacts <span className="text-white">Sharing</span></h1>
                                        <p className="item-content">Share business cards among colleagues and create sustainable network of contacts</p>
                                        <button type="button" className="btn btn-outline-secondary text-white w-md mb-4 mr-2">Video</button>
                                        <button type="button" className="btn btn-primary w-md mb-4 mr-2">Free Trial</button>
                                    </div>
                                    <div className="carousel-item">
                                        <h1 className="item-title">Contacts <span className="text-white">Sharing</span></h1>
                                        <p className="item-content">Share business cards among colleagues and create sustainable network of contacts</p>
                                        <button type="button" className="btn btn-outline-secondary text-white w-md mb-4 mr-2">Video</button>
                                        <button type="button" className="btn btn-primary w-md mb-4 mr-2">Free Trial</button>
                                    </div>
                                </div>
                                <ol className="carousel-indicators">
                                    <li data-target="#carouselCaptions" data-slide-to="0" className="active"></li>
                                    <li data-target="#carouselCaptions" data-slide-to="1"></li>
                                    <li data-target="#carouselCaptions" data-slide-to="2"></li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container-fluid">
                    <div className="row page-second">
                        <div className="col-sm-12 col-md-12 col-lg-4">
                            <div className="card-body">
                                <div id="intro1"></div>
                                <h4 className="card-title">Digitize</h4>
                                <p className="card-detail">Scan contacts’ business cards with the Sansan scanner set or with a phone. The cards are quickly and accurately digitized into contact data by our team, and uploaded to the cloud.</p>
                            </div>
                        </div>
                        <div className="col-sm-12 col-md-12 col-lg-4">
                            <div className="card-body">
                                <div id="intro2"></div>
                                <h4 className="card-title">Organize</h4>
                                <p className="card-detail">Contacts are automatically organized into your company’s database. Add tags, notes and meeting reports to optimize your database and keep track of opportunities.</p>
                            </div>
                        </div>
                        <div className="col-sm-12 col-md-12 col-lg-4">
                            <div className="card-body">
                                <div id="intro3"></div>
                                <h4 className="card-title">Utilize</h4>
                                <p className="card-detail">This database becomes a permanent resource for your company, not to be lost when staff move on, and to be shared within your company as much or little as you like.</p>
                            </div>
                        </div>
                    </div>
                    <div className="row page-third">
                        <div className="col-sm-12 col-md-12 col-lg-6">
                            <div className="card-body">
                                <h4 className="card-title">Digitize business cards in multiple languages</h4>
                                <p className="card-detail">This database becomes a permanent resource for your company, not to be lost when staff move on, and to be shared within your company as much or little as you like.</p>
                            </div>
                        </div>
                        <div className="col-sm-12 col-md-12 col-lg-6 text-left p-0">
                            <img src={process.env.PUBLIC_URL + "static/images/index_diagram01@2x.png"} alt="diagram" className="img-fluid"/>
                        </div>
                    </div>
                    <div className="row page-third row-reverse">
                        <div className="col-sm-12 col-md-12 col-lg-6 bg-white">
                            <div className="card-body">
                                <h4 className="card-title">Store Contacts Permanently</h4>
                                <ul className="card-detail">
                                    <li>Automatic data synchronization between Smartphone and PC.</li>
                                    <li>Contacts are centrally managed and permanently stored in the company database.</li>
                                    <li>Keep all of the contacts data safe while in transmission.</li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-sm-12 col-md-12 col-lg-6 text-left p-0">
                            <img src={process.env.PUBLIC_URL + "static/images/index_diagram02@2x.png"} alt="diagram" className="img-fluid"/>
                        </div>
                    </div>
                    <div className="row page-third">
                        <div className="col-sm-12 col-md-12 col-lg-6">
                            <div className="card-body">
                                <h4 className="card-title">Contacts Sharing</h4>
                                <ul className="card-detail">
                                    <li>Share business cards among colleagues.</li>
                                    <li>Efficiently receive contact data from assistants.</li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-sm-12 col-md-12 col-lg-6 text-left p-0">
                            <img src={process.env.PUBLIC_URL + "static/images/index_diagram03-01@2x.png"} alt="diagram" className="img-fluid"/>
                        </div>
                    </div>
                </div>
                <div className="above-footer"></div>
            </div>
            <Footer/>
            </>
        )
    }
}

export default Home;